(function () {

    angular
        .module('smartertoolsApp')
        .factory('cardsOnFileService', ['$q', '$http', 'refreshToken', cardsOnFileService]);

    function cardsOnFileService($q, $http, refreshToken) {
        const urlBase = apiRootUrl;
        let promise1;

        const dataFactory = {};
        dataFactory.getCardsOnFile = getCardsOnFile;
        dataFactory.saveCard = saveCard;
        dataFactory.deleteCard = deleteCard;
        return dataFactory;

        // -----------------------------------------------

        function getCardsOnFile() {
            if (promise1)
                return promise1;
            promise1 = refreshToken.refreshToken()
                .then(() => $http.get(urlBase + 'v1/account/cards-on-file/all'))
                .then((response) => {
                    promise1 = null;
                    return response.data;
                });
            return promise1;
        }

        function saveCard(card) {
            return refreshToken.refreshToken()
                .then(() => {
                    if (card.PaymentMethodId)
                        return $http.post(urlBase + 'v1/account/cards-on-file/update', JSON.stringify(card));
                    else
                        return $http.post(urlBase + 'v1/account/cards-on-file/add', JSON.stringify(card));
                })
                .then((response) => response.data);
        }

        function deleteCard(card) {
            return refreshToken.refreshToken()
                .then(() => {
                    if (card.PaymentMethodId)
                        return $http.delete(urlBase + 'v1/account/cards-on-file/' + card.PaymentMethodId);
                    else
                        $q.reject('Card does not exist');
                })
                .then((response) => response.data);
        }
    }

})();